import React from 'react';
import { Paper, Typography, Box, Stack, Chip, Divider } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';

const CandidateCertificates = ({ certificates }) => {
    if (!certificates || certificates.length === 0) {
        return null;
    }

    return (
        <Paper 
            elevation={0}
            sx={{ 
                p: 3, 
                mb: 3,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <SchoolIcon sx={{ color: 'text.primary' }} />
                <Typography variant="h6" fontWeight={600} color="text.primary">
                    Certificates & Licenses
                </Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />
            <Stack spacing={2}>
                {certificates.map((cert) => (
                    <Box
                        key={cert.id}
                        sx={{
                            p: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 1,
                            '&:hover': {
                                backgroundColor: 'action.hover'
                            }
                        }}
                    >
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                            {cert.title}
                        </Typography>
                        {cert.description && (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                                {cert.description}
                            </Typography>
                        )}
                        {(cert.expiration_month || cert.expiration_year) && (
                            <Chip
                                label={`Expires: ${cert.expiration_month || ''}/${cert.expiration_year || ''}`}
                                size="small"
                                variant="outlined"
                                sx={{ mt: 1 }}
                            />
                        )}
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
};

export default CandidateCertificates;
